export const SECTION_WRAPPER_PROPS = {
  title: 'DOCUMENTS',
  isHeaderClickable: true,
  defaultIsOpen: true,
  headerConfig: {
    containerStyles: () => ({
      backgroundColor: 'ats-tertiary',
      p: '15px',
    }),
    textStyles: { color: 'ats-primary' },
    iconStyles: { width: '24px', height: '24px' },
  },
  styles: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '6px',
  },
  collapseStyles: {
    display: 'flex',
    flexDirection: 'column',
    padding: '1em 1em',
    backgroundColor: 'white',
  },
};

export const EMPTY_ENTRY = { folderId: '', folderName: '', documents: [] };

export const DOC_TYPE_FIELDS = {
  ats_attachment: ['ats_attachment_id'],
  offer_document_pdf: ['offer_id'],
  offer_document_docx: ['offer_id'],
  additional_document: ['attachment_id'],
};
